// extracted by mini-css-extract-plugin
module.exports = {"hidden":"bookmark_hidden__Lr8NY","textEmphasis":"bookmark_textEmphasis__ccxkG","wrapper":"bookmark_wrapper__jYewX"};